import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NotificationContextType {
  isOpen: boolean;
  openNotificationCenter: () => void;
  closeNotificationCenter: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export function NotificationProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openNotificationCenter = () => setIsOpen(true);
  const closeNotificationCenter = () => setIsOpen(false);

  return (
    <NotificationContext.Provider value={{ isOpen, openNotificationCenter, closeNotificationCenter }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotificationCenter() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotificationCenter must be used within a NotificationProvider');
  }
  return context;
}
